import { render, staticRenderFns } from "./SelectLicenseType.vue?vue&type=template&id=372e5f2b"
import script from "./SelectLicenseType.vue?vue&type=script&lang=js"
export * from "./SelectLicenseType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports